<div class="background-theme">
    @if (title && link) {
        <div class="background-theme__title">
            <a (click)="themaLinkClicked(link)" [href]="link">{{ title }}</a>
        </div>
    }
    @if (title && !link) {
        <div class="background-theme__title">{{ title }}</div>
    }
    @if (text) {
        <div class="background-theme__text">{{ text }}</div>
    }
    @if (image) {
        <div class="background-theme__image">
            <img [src]="image" alt="" role="presentation" />
        </div>
    }
</div>
